import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import {
	CreateAppPayload,
	CreateAppResponse,
	DeleteAppPayload,
	UpdateAppPayload,
	WebhookAppPayload
} from "./NetTypes";

async function createApplicationRequest({ orgId, name, displayName }: CreateAppPayload) {
	return await apiClient
		.post(API.COMMAND.ORGANIZATIONS.APPS.CREATE(orgId), {
			name,
			displayName
		})
		.then((res) => res.data);
}

export function useCreateApp() {
	return useMutation<CreateAppResponse, AxiosError, CreateAppPayload>({
		mutationFn: (payload: CreateAppPayload) => createApplicationRequest(payload)
	});
}

async function deleteApplicationRequest({ orgId, appId, password }: DeleteAppPayload) {
	return await apiClient
		.delete(API.COMMAND.ORGANIZATIONS.APPS.DELETE(orgId, appId), { data: { password } })
		.then((res) => res.data);
}

export function useDeleteAppRequest() {
	return useMutation<any, AxiosError, DeleteAppPayload>({
		mutationFn: (payload: DeleteAppPayload) => deleteApplicationRequest(payload)
	});
}

async function updateApplicationRequest({
	orgId,
	appId,
	name,
	forceSecureConnection
}: UpdateAppPayload) {
	return await apiClient
		.put(API.COMMAND.ORGANIZATIONS.APPS.PUT(orgId, appId), { name, forceSecureConnection })
		.then((res) => res.data);
}

export function useUpdateAppRequest() {
	return useMutation<any, AxiosError, UpdateAppPayload>({
		mutationFn: (payload: UpdateAppPayload) => updateApplicationRequest(payload)
	});
}

async function webhookAppRequest({ orgId, appId, webhook }: WebhookAppPayload) {
	return await apiClient
		.put(API.COMMAND.ORGANIZATIONS.WEBHOOK(orgId, appId), { webhook })
		.then((res) => res.data);
}

export function useWebhookAppRequest() {
	return useMutation<any, AxiosError, WebhookAppPayload>({
		mutationFn: (payload: WebhookAppPayload) => webhookAppRequest(payload)
	});
}
